__webpack_require__.p = "/stellar-burgers/";